(function () {
  const FORM_SEL = '[data-boldzee-search-form]';
  const CHIP_SEL = '[data-boldzee-chip]';
  const PARAM_Q = 'q';
  const PARAM_MODE = 'hb_search';
 
  function collectionUrlFromEl(el) {
    const fromSection = el.closest('[data-boldzee-collection-url]');
    if (fromSection?.dataset?.boldzeeCollectionUrl) return fromSection.dataset.boldzeeCollectionUrl;
    return el.getAttribute('data-collection-url') || '/collections/servicestore';
  }

  function buildRedirectUrl(basePath, query, mode) {
    const path = (basePath || '/collections/servicestore').trim() || '/collections/servicestore';
    const url = new URL(path, window.location.origin);
    url.searchParams.set(PARAM_Q, query);
    url.searchParams.set(PARAM_MODE, mode);
    return url.toString();
  }

  function redirectToCollection(el, query, mode) {
    const q = (query || '').trim();
    if (!q) return;
    const target = buildRedirectUrl(collectionUrlFromEl(el), q, mode);
    window.location.assign(target);
  }

  function wireForms() {
    document.querySelectorAll(FORM_SEL).forEach((form) => {
      if (form.dataset.boldzeeWired) return;
      form.dataset.boldzeeWired = '1';

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="search"], input[type="text"], input:not([type="hidden"])');
        const mode = form.getAttribute('data-search-mode') || 'ai';
        redirectToCollection(form, input?.value ?? '', mode);
      });
    });
  }  

  function wireChips() {
    document.querySelectorAll(CHIP_SEL).forEach((chip) => {
      if (chip.dataset.boldzeeWired) return;
      chip.dataset.boldzeeWired = '1';

      chip.addEventListener('click', () => {
        const q = chip.getAttribute('data-search-query') || chip.textContent || '';
        const mode = chip.getAttribute('data-search-mode') || 'ai';
        redirectToCollection(chip, q, mode);
      });
    });
  }

  function stripSearchParams() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(PARAM_Q) && !params.has(PARAM_MODE)) return;
    params.delete(PARAM_Q);
    params.delete(PARAM_MODE);
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
    window.history.replaceState({}, '', next);
  }

  function applyFromUrlOnce() {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get(PARAM_Q) || '').trim();
    const mode = params.get(PARAM_MODE);
    if (!q || !mode) return false;

    if (mode === 'ai') {
      if (window.HbAiSearch?.applyQuery) {
        window.HbAiSearch.applyQuery(q);
        stripSearchParams();
        return true;
      }
      return false;
    }

    if (mode === 'filter') {
      const root = document.querySelector('[data-collection-filter-root]');
      const input = root?.querySelector('.hb-search-box input');
      if (root && input) {
        input.value = q;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        stripSearchParams();
        return true;
      }
      return false;
    }

    return false;
  }

  function pollCollectionLanding(maxMs) {
    const start = Date.now();
    const tick = () => {
      if (applyFromUrlOnce()) return;
      if (Date.now() - start > maxMs) return;
      requestAnimationFrame(tick);
    };
    tick();
  }

  function wireNavSearchMobile() {
    document.querySelectorAll('[data-nav-search-toggle]').forEach((btn) => {
      if (btn.dataset.boldzeeNavWired) return;
      btn.dataset.boldzeeNavWired = '1';

      const drawerId = btn.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;
      if (!drawer) return;

      const setOpen = (open) => {
        drawer.classList.toggle('open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          const input = drawer.querySelector('input[type="search"], input[type="text"]');
          requestAnimationFrame(() => input?.focus());
        }
      };

      btn.addEventListener('click', () => {
        setOpen(!drawer.classList.contains('open'));
      });
    });

    document.querySelectorAll('[data-nav-search-close]').forEach((closeBtn) => {
      if (closeBtn.dataset.boldzeeNavWired) return;
      closeBtn.dataset.boldzeeNavWired = '1';

      closeBtn.addEventListener('click', () => {
        const drawer = closeBtn.closest('[data-nav-search-drawer]');
        if (!drawer) return;
        drawer.classList.remove('open');
        const toggle = document.querySelector(`[aria-controls="${drawer.id}"]`);
        toggle?.setAttribute('aria-expanded', 'false');
      });
    });
  }
function wireAiLinks() {
    document.querySelectorAll('[data-search-mode="ai"]').forEach((link) => {
        if (link.dataset.boldzeeWired) return;
        link.dataset.boldzeeWired = '1';

        link.addEventListener('click', (e) => {
            e.preventDefault();

            const q = link.dataset.searchQuery || link.textContent.trim();

            redirectToCollection(link, q, 'ai');
        });
    });
}


function wireTypewriters() {
  document.querySelectorAll(FORM_SEL).forEach((form) => {
    if (form.dataset.boldzeeTypedWired) return;
    form.dataset.boldzeeTypedWired = '1';
    initTypewriter(form);
  });

  function initTypewriter(form) {
    var input = form.querySelector('[data-typed-input]');
    var overlay = form.querySelector('[data-fake-placeholder]');
    var typedEl = form.querySelector('[data-typed-text]');
    if (!input || !overlay || !typedEl) return;
    var phrases = (input.dataset.typedPhrases || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!phrases.length) return;

    var phraseIndex = 0, charIndex = 0, deleting = false;
    var typingSpeed = 45, deletingSpeed = 25, pauseAfterType = 1400, pauseAfterDelete = 300;

    function updateVisibility() {
      var shouldHide = document.activeElement === input || input.value.length > 0;
      overlay.classList.toggle('is-hidden', shouldHide);
    }

    function tick() {
      updateVisibility();
      if (overlay.classList.contains('is-hidden')) {
        setTimeout(tick, 250);
        return;
      }
      var current = phrases[phraseIndex];
      if (!deleting) {
        charIndex++;
        typedEl.textContent = current.slice(0, charIndex);
        setTimeout(tick, charIndex === current.length ? (deleting = true, pauseAfterType) : typingSpeed);
      } else {
        charIndex--;
        typedEl.textContent = current.slice(0, charIndex);
        if (charIndex === 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          setTimeout(tick, pauseAfterDelete);
        } else {
          setTimeout(tick, deletingSpeed);
        }
      }
    }

    input.addEventListener('focus', updateVisibility);
    input.addEventListener('blur', updateVisibility);
    input.addEventListener('input', updateVisibility);
    tick();
  }
}



  function init() {
    wireForms();
    wireChips();
    wireAiLinks();
    wireNavSearchMobile();
  wireTypewriters(); 

    const params = new URLSearchParams(window.location.search);
    if (params.get(PARAM_Q) && params.get(PARAM_MODE)) {
      pollCollectionLanding(8000);
    }
  }



  



  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
